import { render, staticRenderFns } from "./overallCampaignsPieChart.vue?vue&type=template&id=6518058b&scoped=true"
import script from "./overallCampaignsPieChart.vue?vue&type=script&lang=js"
export * from "./overallCampaignsPieChart.vue?vue&type=script&lang=js"
import style0 from "./overallCampaignsPieChart.vue?vue&type=style&index=0&id=6518058b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518058b",
  null
  
)

export default component.exports